var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderResult"},[_c('div',{staticClass:"card bg-secondary rounded overflow-hidden d-flex justify-content-center align-items-center",staticStyle:{"width":"300px"}},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.order?.content,"type":"audio/mpeg"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }